import { EnterAmountType } from '../EnterAmountPage/EnterAmountProvider';

export const SummaryBottomSheetProvider = (t, type) => {
  if (type === EnterAmountType.MICROLOAN) {
    return {
      title: t('Confirm interest charges'),
      titleStyle: 'bottom-sheet-title',
      itemTitle: t('Check to agree to interest charges'),
      alertMessage: t(
        'By checking this box, you acknowledge that this transaction will incur interest charges',
      ),
      alertStyle: 'bottom-sheet-items',
      buttonTitle: t('Confirm'),
    };
  }

  return {};
};
